import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import PatientsPage from "@/pages/Patients";
import PatientProfile from "@/pages/PatientProfile";
import ConsultationPage from "@/pages/Consultation";
import ReportsPage from "@/pages/Reports";
import SettingsPage from "@/pages/Settings";
import AppointmentsPage from "@/pages/Appointments";
import InvoicesPage from "@/pages/Invoices";
import AnalyticsPage from "@/pages/Analytics";
import ArchivePage from "@/pages/Archive";
import OwnerPortal from "@/pages/OwnerPortal";
import AppShell from "@/components/AppShell";
import ScrollLockGuard from "@/components/ScrollLockGuard";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-pf-bg">
        <div className="pf-card px-6 py-4 text-sm text-pf-text-secondary">Loading Pawfile…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user && user !== null) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <ScrollLockGuard />
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/portal/:token" element={<OwnerPortal />} />

            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/patients" element={<Protected><PatientsPage /></Protected>} />
            <Route path="/archive" element={<Protected><ArchivePage /></Protected>} />
            <Route path="/patients/:id" element={<Protected><PatientProfile /></Protected>} />
            <Route path="/consultations/:id" element={<Protected><ConsultationPage /></Protected>} />
            <Route path="/reports" element={<Protected><ReportsPage /></Protected>} />
            <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="/appointments" element={<Protected><AppointmentsPage /></Protected>} />
            <Route path="/invoices" element={<Protected><InvoicesPage /></Protected>} />
            <Route path="/analytics" element={<Protected><AnalyticsPage /></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}
